import React from 'react';
import Grid from '../../../../../../components/atomic/Grid';
import useDesktop from '../../../../../../hooks/useDesktop';
import { useSectionStyles } from '../sectionStyles';

export function OverviewGridItem({ children, showMaxwidth, className }) {
  const isDesktop = useDesktop();
  const classes = useSectionStyles();

  // If desktop and classes is not passed to props, return no class
  const classInner =
    isDesktop && classes
      ? `${classes.removePaddingBottom} ${className}`
      : className;
  return showMaxwidth ? (
    <Grid item md={12} lg={12} sm={12} xs={12} className={classInner}>
      {children}
    </Grid>
  ) : (
    <Grid item md={12} lg={6} sm={12} xs={12} className={classInner}>
      {children}
    </Grid>
  );
}
